<template>
  <b-container class="page-container">
    <Breadcrumbs currentpage="Kies je organisatie" />

    <h1>Je account is gekoppeld aan meerdere organisaties</h1>

    <b-alert show variant="warning"
      ><font-awesome-icon icon="exclamation-circle" /> Opgelet! Het lijkt erop
      dat je account gekoppeld is aan meerdere organisaties. Voor welke
      organisatie wil je een reservatieaanvraag indienen?
    </b-alert>

    <h2>Kies de organisatie voor deze aanvraag</h2>

    <b-row class="pt-4">
      <b-col
        v-for="account in accounts"
        :key="account.ContactID"
        class="card-userswitch mt-4 mt-lg-0"
        xs="12"
        sm="12"
        md="12"
        lg="6"
        xl="4"
      >
        <b-card class="mb-4"
          ><p>
            {{ account.CompanyName }}
            <small>{{ account.FullNameWOSalutation }} </small>
          </p>
          <p></p>
          <b-button
            variant="primary"
            :value="account.ContactID"
            :disabled="!account.IsCustomerActive"
            @click="selectContactID"
            >Verder gaan als {{ account.CompanyName }}</b-button
          ></b-card
        >
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Breadcrumbs from '@/components/header/BreadCrumbs'
export default {
  components: { Breadcrumbs },
  data() {
    return {
      visibleStatuses: ['3. Actief', '4. Tijdelijk account']
    }
  },
  computed: {
    accounts: function() {
      return this.$store.state.accounts.filter(account =>
        this.visibleStatuses.includes(account.CUST_Status)
      )
    }
  },
  methods: {
    async selectContactID(event) {
      await this.$store.commit('setContactID', {
        contactID: event.target.value
      })
      this.$router.push({ name: 'index', params: { loggedIn: true } })
    }
  }
}
</script>
<style scoped lang="scss">
.alert {
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 18px !important;
}
.card-userswitch {
  p {
    font-size: 20px !important;
    line-height: 24px;
    font-family: 'DecimaPro-bold';
    text-transform: uppercase;
  }
  .btn {
    font-size: 20px !important;
  }
}
h1 {
  font-size: 50px !important;
}
</style>
